module.exports = __webpack_public_path__ + "img/vendorproof-logo@1x.276023fa.png";